"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertWidget = void 0;
const core_1 = require("@material-ui/core");
const icons_1 = require("client/components/icons");
const button_1 = require("client/components/material/button");
const select_1 = require("client/components/material/select");
const text_area_1 = require("client/components/material/text-area");
const text_field_1 = require("client/components/material/text-field");
const ui_1 = require("client/components/ui");
const store_1 = require("client/modules/app-settings/store");
const store_2 = require("client/modules/dashboard/store");
const store_3 = require("client/modules/sites/modules/sites-list/store");
const store_4 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const React = require("react");
const react_html_parser_1 = require("react-html-parser");
require("./alert-widget.less");
const dummyAlert = {
    subject: "",
    message: "",
    siteId: null,
    groupId: null
};
var Recipients;
(function (Recipients) {
    Recipients["All"] = "1";
    Recipients["IMB"] = "2";
    Recipients["Pharm"] = "3";
})(Recipients || (Recipients = {}));
let AlertWidget = class AlertWidget extends React.Component {
    constructor() {
        /** Create an alert based on group ID and site ID for filtering. */
        super(...arguments);
        this.alertCount = 0;
        this.newMessage = dummyAlert;
        this.alerts = [];
        this.showNew = false;
        this.userId = store_4.usersStore &&
            store_4.usersStore.user &&
            store_4.usersStore.user.value &&
            store_4.usersStore.user.value.id;
        this.showSuccess = false;
        this.recipient = Recipients.Pharm;
        this.siteId = null;
        this.siteName = "";
        this.loadAlertsCount = null;
        this._isMounted = false;
        // public loadMessages = async () => {
        //   // await patientsStore.duplicatePatients(); //B-038 2.0
        //   await dashboardStore.readMessage(this.userId, this.loadAlertsCount);
        //   // B-046 TMPP > Claims > Failed to Reverse - Remove Notification Tagging A-002 with this ticket as it is somewhat related.
        //   const filteredData = dashboardStore.alerts?.filter((item: any) => { // E-026.1
        //     if (!item.alert.subject.toLowerCase().includes("pending approval")) {
        //       return item;
        //     }
        //   });
        //   this.alerts = (usersStore.permissions.UpdateOrderApprover
        //     ? dashboardStore.alerts 
        //     : filteredData
        //   ).map((alert: { alert: IAlert }) => alert.alert); // E-026.1
        //   this.alertCount = this.alerts.length;
        // };
        // B-108
        this.loadMessages = async () => {
            try {
                const isDevAdmin = store_4.usersStore.user.value.groupId === 1 || store_4.usersStore.user.value.groupId === 4;
                const assignedSites = store_4.usersStore.user.value.sites || [];
                // Ensure readMessage is awaited if it returns a promise
                await store_2.dashboardStore.readMessage(this.userId, this.loadAlertsCount);
                // Robust filtering
                const filteredData = (store_2.dashboardStore.alerts || []).filter((item) => !item.alert.subject.toLowerCase().includes("pending approval"));
                const finalData = store_4.usersStore.permissions.UpdateOrderApprover
                    ? (store_2.dashboardStore.alerts || [])
                    : filteredData;
                if (!isDevAdmin) {
                    this.alerts = (finalData || [])
                        .filter((item) => assignedSites.includes(item.alert.siteId))
                        .map((alert) => alert.alert);
                }
                else {
                    this.alerts = (finalData || [])
                        .map((alert) => alert.alert);
                }
                this.alertCount = this.alerts.length;
            }
            catch (error) {
                console.error('Error loading messages:', error);
                this.alerts = [];
                this.alertCount = 0;
            }
        };
        this.updateProperty = (_event, _key) => {
            const key = _key;
            const value = _event.target.value;
            if (_key === "subject" && value.length > 255) {
                _event.target.value = value.slice(0, -1);
            }
            this.newMessage[key] = value;
        };
        this.handleMessageSeen = async (alertId, ev, index) => {
            ev.preventDefault();
            await store_2.dashboardStore.seenMessage(alertId, this.userId);
            this.loadMessages();
        };
        this.handleSubmit = async () => {
            /**
             * @desc Strips non-text from a string.
             * @param msg The string with potential HTML/JS.
             */
            const sanitize = (msg) => {
                const tmp = document.implementation.createHTMLDocument("New").body;
                tmp.innerHTML = msg;
                return tmp.textContent || tmp.innerText || "";
            };
            this.showNew = false;
            this.showSuccess = true;
            const msg = this.newMessage;
            const msgSubject = sanitize(msg.subject);
            const message = sanitize(msg.message);
            const siteId = this.recipient === Recipients.Pharm ? this.siteId : null; // msg.siteId;
            const siteName = this.recipient === Recipients.Pharm ? `(${this.siteName}) ` : "(Admin) ";
            const subject = siteName.concat(msgSubject);
            const groupId = msg.groupId;
            const userId = this.userId;
            const alertType = siteId ? store_2.AlertType.Null : store_2.AlertType.Admin;
            const alert = {
                subject,
                message,
                siteId,
                groupId,
                userId,
                alertType
            };
            await store_2.dashboardStore.createAlert(alert);
            this.newMessage = dummyAlert;
            this.loadMessages();
        };
        this.renderMessages = () => (React.createElement("div", null, this.alerts.map((alert, index) => alert &&
            alert.date && (React.createElement("details", { className: "db-alert", key: index },
            React.createElement("summary", { className: "db-alert__subject" },
                React.createElement("div", { className: "db-alert__subject-layout" },
                    React.createElement("span", { className: "left" },
                        React.createElement(icons_1.NotifyIcon, { fill: "rgba(38, 50, 78, .2)" }),
                        alert && alert.subject),
                    React.createElement("span", { className: "right" },
                        (alert === null || alert === void 0 ? void 0 : alert.date) && moment.tz(alert.date, Intl.DateTimeFormat().resolvedOptions().timeZone).format("MM/DD/YY hh:mm A z"),
                        React.createElement("span", { className: "right-close", onClick: (ev) => this.handleMessageSeen(alert.id, ev, index) },
                            React.createElement(icons_1.CloseIcon, { fill: "red" }))))),
            React.createElement("div", { className: "db-alert__message" }, alert && react_html_parser_1.default(alert.message)))))));
        this.stopGrid = (event) => event.stopPropagation();
        this.renderNew = () => {
            const handleSelect = (e) => {
                this.recipient = e;
            };
            const handleSelectSite = (e) => {
                this.siteId = Number(e);
                const selectedOption = this.availableOptions.find((option) => option.value === e);
                this.siteName = selectedOption.label;
            };
            const receive = [
                {
                    id: 1,
                    label: "Everyone",
                    value: Recipients.All
                },
                // {
                //   id: 2, // Not ready yet.
                //   label: "IMB Staff",
                //   value: Recipients.IMB,
                // },
                {
                    id: 3,
                    label: "Specific Pharmacy",
                    value: Recipients.Pharm
                }
            ];
            return (React.createElement("div", { onMouseDown: e => this.stopGrid(e) },
                React.createElement(ui_1.UiForm, { buttons: [
                        React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: () => (this.showNew = false) }, "Cancel"),
                        "Submit"
                    ], id: "render-new-message", onSubmit: this.handleSubmit, title: "Create New Notification" },
                    React.createElement("div", { className: "recipient-wrapper" },
                        store_4.usersStore.user.value.user && (React.createElement(select_1.MaterialSelect, { options: receive, required: true, value: this.recipient, label: "Recipient", onSelect: handleSelect })),
                        ((store_4.usersStore.user.value.user &&
                            this.recipient === Recipients.Pharm) ||
                            store_4.usersStore.user.value.siteUser) && (React.createElement(select_1.MaterialSelect, { options: this.availableOptions, required: true, value: this.siteId ? this.siteId.toString() : "", label: "Pharmacy", onSelect: handleSelectSite, searchable: true }))),
                    React.createElement(text_field_1.MaterialTextField, { label: "Subject", onChange: e => this.updateProperty(e, "subject"), required: true }),
                    React.createElement(text_area_1.MaterialTextArea, { placeholder: "Enter a message...", onChange: e => this.updateProperty(e, "message"), required: true }))));
        };
        /** :) */
        this.renderSuccessMessage = () => {
            setTimeout(() => {
                this.showSuccess = false;
            }, 3000);
            return (React.createElement("div", { className: "alert-success" },
                React.createElement("div", null, "success \u2714")));
        };
    }
    get availableOptions() {
        if (store_4.usersStore.user.value.user) {
            return store_3.sitesListStore.sites.value
                ? store_3.sitesListStore.sites.value.map((site, i) => ({
                    id: i,
                    label: site.displayName || site.name,
                    value: site.id.toString()
                }))
                : [];
        }
        else {
            return [
                {
                    id: 0,
                    label: store_4.usersStore.user.value.site.name,
                    value: store_4.usersStore.user.value.site.id.toString()
                }
            ];
        }
    }
    async componentWillReceiveProps(props) {
        if (props.shouldReloadMessages) {
            await this.loadMessages();
            this.props.setShouldReloadMessagesToFalse();
        }
    }
    componentWillMount() {
        this.loadMessages();
    }
    async componentDidMount() {
        store_3.sitesListStore.loadSitesNoRelation();
        if (store_4.usersStore.user.value.siteUser) {
            this.siteId = store_4.usersStore.user.value.site.id;
            this.siteName =
                store_4.usersStore.user.value.site.displayName ||
                    store_4.usersStore.user.value.site.name;
        }
        this.loadAlertsCount = await store_1.appSettingsStore.getLoadAlertsCount();
        this._isMounted = true;
        this.loadMessagesInterval = window.setInterval(() => {
            if (this._isMounted) {
                this.loadMessages();
            }
        }, 10000);
    }
    componentWillUnmount() {
        this._isMounted = false;
        window.clearInterval(this.loadMessagesInterval);
    }
    render() {
        // console.log("Achoo");
        // console.log("Bless you");
        // console.log("Thank you");
        return (React.createElement("div", { className: "alert-widget widget" }, store_4.usersStore.permissions.ViewAlertsWidget ? (React.createElement("div", { onMouseDown: e => this.stopGrid(e) },
            React.createElement("div", { className: "alert-widget__create" },
                React.createElement(core_1.Typography, { variant: "title", gutterBottom: true },
                    "Displaying (",
                    this.alertCount,
                    ") Alerts"),
                React.createElement("div", { className: "alert-widget-button-container" },
                    React.createElement(button_1.MaterialButton, { flat: true, secondary: true, className: "alert-widget__button alert-widget__button--clear-all", onClick: this.props.showClearAllAlertsConfirmation }, "Clear all"),
                    !this.showNew && store_4.usersStore.permissions.CreateAlerts && (React.createElement(ui_1.UiButton, { className: "alert-widget__button", primary: true, onClick: () => (this.showNew = true) }, "Create New Alert")))),
            this.showNew
                ? this.renderNew()
                : this.alerts && this.renderMessages(),
            this.showSuccess && this.renderSuccessMessage())) : (store_4.usersStore.showLock())));
    }
};
__decorate([
    mobx_1.observable
], AlertWidget.prototype, "alertCount", void 0);
__decorate([
    mobx_1.observable
], AlertWidget.prototype, "newMessage", void 0);
__decorate([
    mobx_1.observable
], AlertWidget.prototype, "alerts", void 0);
__decorate([
    mobx_1.observable
], AlertWidget.prototype, "showNew", void 0);
__decorate([
    mobx_1.observable
], AlertWidget.prototype, "userId", void 0);
__decorate([
    mobx_1.observable
], AlertWidget.prototype, "showSuccess", void 0);
__decorate([
    mobx_1.observable
], AlertWidget.prototype, "recipient", void 0);
__decorate([
    mobx_1.observable
], AlertWidget.prototype, "siteId", void 0);
__decorate([
    mobx_1.observable
], AlertWidget.prototype, "siteName", void 0);
__decorate([
    mobx_1.observable
], AlertWidget.prototype, "loadAlertsCount", void 0);
__decorate([
    mobx_1.computed
], AlertWidget.prototype, "availableOptions", null);
AlertWidget = __decorate([
    mobx_react_1.observer
], AlertWidget);
exports.AlertWidget = AlertWidget;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/dashboard/modules/widget-grid/components/alert-widget/alert-widget.tsx
// module id = 3301
// module chunks = 0